// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".language-switcher button[data-v-49667de6]{border-bottom:2px solid transparent;border-radius:0;padding-left:.25rem;padding-right:.25rem}.language-switcher button.active[data-v-49667de6]{border-bottom:2px solid #2f0db9;border-bottom:2px solid var(--primary-500,#2f0db9);color:#000;color:var(--shade-black,#000);transition-delay:.25s}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
